export default __webpack_public_path__ + "static/media/remove.e7b96fb1.svg";